/**
 * Crisp chat utilities.
 * @see https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/npm/#session-continuity
 */

/**
 * Clears Crisp session and token. Call this on user logout to unbind
 * the current session and start fresh on next login.
 */
export async function clearCrispSession() {
  if (typeof window === 'undefined') return;
  try {
    const { Crisp } = await import('crisp-sdk-web');
    Crisp.setTokenId();
    Crisp.session.reset();
  } catch (e) {
    // Crisp may not be loaded or configured
  }
}
